// 19.1.2.14 Object.keys(O)
var toObject = require('./$.to-object');

require('./$.object-sap')('keys', function($keys){
  return function keys(it){
    return $keys(toObject(it));
  };
});


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/core-js/library/modules/es6.object.keys.js
 ** module id = 298
 ** module chunks = 1
 **/